import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import { DashboardCard } from "../../../components/DashboardCard/DashboardCard";
import { SearchableDashboard } from "../../../constants";

interface Props {
  label: string;
  dashboards: SearchableDashboard[];
  isOpen: boolean;
  onToggle: () => void;
  // Real per-category field from the backend (docs/needed-endpoints.md §9/§11) - colors the
  // collapsible arrow specifically, distinct from CATEGORY_COLORS (categoryColors.ts), which is a
  // client-side name-keyed map used for DashboardCard's pill/Settings' Engagement dots. Falls back
  // to the chevron's existing themed color when not set (e.g. category predates this field).
  color?: string | null;
  onOpenDashboard?: (dashboard: SearchableDashboard) => void;
}

export const CollapsibleDashboardGroup = (props: Props) => {
  const { label, dashboards, isOpen, onToggle, color, onOpenDashboard } = props;

  return (
    <div className="collapsible_dashboard_group" data-test-id={`dashboard-group-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="collapsible_dashboard_group_header_row">
        <button
          className="collapsible_dashboard_group_chevron"
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-label={isOpen ? "Collapse" : "Expand"}
          style={color ? { color } : undefined}
        >
          {isOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </button>

        <button className="collapsible_dashboard_group_header" onClick={onToggle} aria-expanded={isOpen}>
          {label} <span className="collapsible_dashboard_group_count">({dashboards.length})</span>
        </button>
      </div>

      {isOpen && (
        <div className="collapsible_dashboard_group_cards">
          {dashboards.map((dashboard) => (
            <DashboardCard
              key={dashboard.key}
              dashboard={dashboard}
              onOpen={onOpenDashboard ? () => onOpenDashboard(dashboard) : undefined}
            />
          ))}
        </div>
      )}
    </div>
  );
};
